import { webOrigin } from '@shared/config';
import { fromGlobalId } from '@shared/utils/global-id';
import { getBaseWebUrlFromTenant } from '@shared/utils/tenant';
import { joinURL } from '@shared/utils/url';

const getTenantId = (tenantId: string): string => {
  try {
    return fromGlobalId(tenantId);
  } catch {
    return tenantId;
  }
};

export const webURL = (page: string, query: Record<string, string>): string => {
  const querystring = new URLSearchParams(query).toString();
  const origin =
    getBaseWebUrlFromTenant(getTenantId(query.tenantId ?? '')) ?? webOrigin;

  return joinURL(
    origin,
    'redirect',
    `?page=${page}${querystring !== '' ? '&' + querystring : ''}`,
  );
};
